import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import BootstrapVue3 from "bootstrap-vue-3";
import VueSmoothScroll from 'vue3-smooth-scroll'
import { createHead } from '@unhead/vue'
import { register } from 'swiper/element/bundle';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './assets/sass/style.scss';

gsap.registerPlugin(ScrollTrigger);
const head = createHead()
// register Swiper custom elements
register();

const app = createApp(App).use(store).use(router).use(i18n).use(gsap).use(BootstrapVue3).use(head).use(VueSmoothScroll);

// Wait for the router's initial navigation (including the async route
// component's chunk) to resolve before mounting, so prerendering captures
// real page content instead of an empty shell.
router.isReady().then(() => {
  app.mount("#app");
  // Signal to the prerenderer (see vue.config.js) that content is ready.
  requestAnimationFrame(() => {
    setTimeout(() => document.dispatchEvent(new Event('app-rendered')), 200);
  });
});